import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa23c7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "download", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "refresh", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "graph",
  src: "",
  alt: "",
  usemap: "#canvas-map"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "graphCanvas",
  usemap: "#canvas-map"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("map", {
  name: "canvas-map",
  id: "canvasMap"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_GraphControls = _resolveComponent("GraphControls")!

  return (_openBlock(), _createElementBlock("div", {
    id: "graphWrapper",
    class: _normalizeClass({ loading: _ctx.loading })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "button--icon",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args)))
      }, _hoisted_3),
      _createElementVNode("button", {
        class: "button--icon",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resizeGraph && _ctx.resizeGraph(...args)))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", {
      id: "canvasWrapper",
      class: _normalizeClass({ scaled: _ctx.scaled })
    }, [
      _createVNode(_component_Loader, {
        show: _ctx.loading,
        message: 'Loading Graph'
      }, null, 8, ["show"]),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8
    ], 2),
    _createVNode(_component_GraphControls, { onResize: _ctx.resizeGraph }, null, 8, ["onResize"])
  ], 2))
}